import { ChangeDetectionStrategy, Component, EventEmitter, inject, model } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';
import {
  ProjectHistoryTableEntry,
  ProjectVersionHistoryTableComponent
} from 'app/modules/project/components/project/project-version-history/project-version-history-table/project-version-history-table.component';
import { ProjectModel } from 'app/modules/project/model/project.model';
import { ProjectDataService } from 'app/modules/project/service/project-data.service';
import { ModalComponent } from 'app/modules/shared/modal/modal.component';

@Component({
  selector: 'app-pick-project-version',
  imports: [
    ModalComponent,
    TranslateModule,
    ProjectVersionHistoryTableComponent
  ],
  templateUrl: './pick-project-version.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PickProjectVersionComponent {
  private readonly projectDataService = inject(ProjectDataService);
  private readonly projectModel = inject(ProjectModel);

  public project = this.projectModel.currentProject;

  public selectedEntry = model<ProjectHistoryTableEntry | undefined>(undefined);

  public title = '';
  public message = '';
  public submitButtonText = '';

  public finish = new EventEmitter<number>();

  public history = toSignal(this.projectDataService.loadProjectHistory(this.projectModel.currentProject.id));


  public cancel() {
      this.finish.emit(undefined);
  }

  public submitSelectedVersion() {
      this.finish.emit(this.selectedEntry()?.projectVersion);
  }

}
